import React, { useState, useEffect } from 'react'
import { motion } from 'motion/react'
import type { FieldValues } from '../../fieldTypes'

const colors = [
  'bg-rose-400', 'bg-orange-400', 'bg-amber-400', 'bg-lime-400',
  'bg-emerald-400', 'bg-teal-400', 'bg-cyan-400', 'bg-sky-400',
  'bg-blue-400', 'bg-indigo-400', 'bg-violet-400', 'bg-purple-400',
]

export function CascadingGrid({ values = {} }: { values?: FieldValues }) {
  const [key, setKey] = useState(0)
  const staggerDelay = values.staggerDelay ?? 0.06
  const initialScale = values.initialScale ?? 0.8
  const initialY = values.initialY ?? 10
  const columns = values.columns ?? 4
  const gap = values.gap ?? 8

  useEffect(() => {
    const interval = setInterval(() => setKey((k) => k + 1), 3500)
    return () => clearInterval(interval)
  }, [])

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: staggerDelay },
    },
  }

  const item = {
    hidden: { opacity: 0, scale: initialScale, y: initialY },
    show: { opacity: 1, scale: 1, y: 0 },
  }

  return (
    <div className="flex items-center justify-center h-full p-3">
      <motion.div
        key={key}
        variants={container}
        initial="hidden"
        animate="show"
        className="grid"
        style={{ gridTemplateColumns: `repeat(${columns}, 1fr)`, gap }}
      >
        {colors.map((color, i) => (
          <motion.div
            key={i}
            variants={item}
            className={`w-8 h-8 rounded-lg ${color}`}
          />
        ))}
      </motion.div>
    </div>
  )
}
